import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/index.js";
import { P } from "../Text/index.js";
import { disclaimerVariants } from "./Disclaimer.variants.js";
function Disclaimer({ children, className, ...props }) {
    const { paragraph } = disclaimerVariants(props);
    const paragraphClasses = cn(paragraph(), className);
    return /*#__PURE__*/ jsx(P, {
        palette: "neutral",
        shade: "10",
        textStyle: "body2",
        className: paragraphClasses,
        children: children
    });
}
export { Disclaimer };
